/**
 *
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

type PagesNo = {
  target: string | null;
  no: number;
  pageRows: number;
};

interface SetPageNostate {
  pagesNo: Array<PagesNo>;
  pageNo: PagesNo | null;
  getPageNo: (activePageId: string | null) => void;
  setPagesNo: ({
    target,
    no,
    pageRows,
    activePageId,
  }: PagesNo & { activePageId: string | null }) => void;
  resetPageNo: () => void;
}

const usePageNoStore = create<SetPageNostate>()(
  persist(
    (set, get) => ({
      pagesNo: [],
      pageNo: null,
      pageRows: 100,

      setPagesNo: ({
        target,
        no,
        pageRows,
        activePageId,
      }: PagesNo & { activePageId: string | null }) => {
        const { pagesNo } = get();
        const dpPageNo = pagesNo.find((pageNo) => pageNo.target === target);
        const filterPageNo = pagesNo.filter(
          (pageNo) => pageNo.target !== target
        );

        set({
          pagesNo: !dpPageNo?.target
            ? [...pagesNo, { target, no, pageRows }]
            : [
                ...filterPageNo,
                {
                  ...dpPageNo,
                  no,
                  pageRows,
                },
              ],
        });

        const { getPageNo } = get();
        getPageNo(activePageId);
      },

      getPageNo: (activePageId) => {
        const { pagesNo } = get();
        const pageNo = pagesNo.find((pages) => pages.target === activePageId);

        set({
          pageNo: pageNo,
        });
      },
      resetPageNo: () => {
        set({
          pageNo: null,
        });
      },
    }),
    {
      name: "pageNo-storage",
      partialize: (state) => ({
        pagesNo: state.pagesNo,
      }),
    }
  )
);

export default usePageNoStore;
